import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class TimeRangeValidator {
  static checkValues: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const fromValue = control.value?.from;
    const toValue = control.value?.to;

    if (fromValue && toValue && fromValue.isAfter(toValue)) {
      return { valueFromGraterThenTo: true };
    }

    return null;
  };
}